import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  clearBillingSessionUrl,
  createBillingPortalSession,
} from '../../redux/subscription/subscriptionSlice';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import StyledButton from '../../components/Common/StyledButton';

export default function PaymentSettings() {
  const url = useAppSelector((state) => state.subscription.customerPortalUrl);
  const { id: coachId } = useAppSelector((state) => state.coach.coach);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!url && coachId) {
      dispatch(createBillingPortalSession({ coachId }));
    }
  }, [dispatch, coachId, url]);

  const handleClick = () => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  useEffect(
    () => () => {
      dispatch(clearBillingSessionUrl());
    },
    [dispatch]
  );

  return (
    <CoachPageLayout>
      <Box
        sx={{
          width: '100%',
          height: '80vh',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          backgroundColor: 'transparent',
          padding: '24px',
          borderRadius: '16px',
          overflowX: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '94px',
            gap: '32px',
            width: '100%',
            maxWidth: '500px',
          }}
        >
          <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
            <Typography variant="bodyBold" fontSize={24}>
              {t('payment.paymentSettings')}
            </Typography>
          </Box>
          <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
            <Typography variant="bodyRegular" textAlign="center">
              {t('payment.paymentSettingsDesc')}
            </Typography>
          </Box>
          {url && (
            <Box width="100%" sx={{ alignContent: 'center', textAlign: 'center' }}>
              <StyledButton onClick={handleClick}>{t('payment.gotoPaymentSettings')}</StyledButton>
            </Box>
          )}
        </Box>
      </Box>
    </CoachPageLayout>
  );
}
